import * as React from "react";
import { PageHeader } from "~/components/PageHeader";
import { ImageLoader } from "~/components/ImageLoader";
import { RWA_COIN_ICON } from "~/consts";
import { Badge, BadgeVariants } from "~/components/Badge";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Anchor } from "~/components/Anchor";
import { faExternalLink } from "@fortawesome/pro-regular-svg-icons";
import { PlatformUserEvents } from "~/modules/analytics/events/platforms";
import { addUtmTrackingToUrl } from "~/utils/addUtmTrackingToUrl";
import { Platform } from "../..";
import { isPartnerNetwork } from "~/modules/networks/lib/isPartnerNetwork";
import { DescriptionDisplay } from "~/components/DescriptionDisplay";

// // // //

/**
 * Header component for platform pages displaying platform info and description
 */
export function PlatformHeader(props: { platform: Platform }) {
    const { platform } = props;

    const isPartner = isPartnerNetwork({ slug: platform.slug });

    return (
        <>
            <PageHeader
                title={
                    <>
                        {platform.name}
                        {!isPartner && (
                            <Badge
                                variant={BadgeVariants.grayOutline}
                                label="BETA"
                                size="sm"
                                className="mt-1 tracking-wider"
                            />
                        )}
                    </>
                }
                icon={
                    <ImageLoader
                        src={platform.icon_url || RWA_COIN_ICON}
                        alt={`${platform.name} Icon`}
                        fallbackSrc={RWA_COIN_ICON}
                        className="h-10 w-10 min-w-10 rounded-full"
                    />
                }
            />

            {platform.asset_class_stats.length > 0 && (
                <div className="flex items-center gap-3 flex-wrap">
                    {/* {isPartner && (
                        <Badge
                            variant={BadgeVariants.blue}
                            label={
                                <>
                                    <FontAwesomeIcon
                                        icon={faBadgeCheck}
                                        className="h-3 w-3 mr-1"
                                        aria-hidden="true"
                                    />
                                    Verified
                                </>
                            }
                            size="md"
                            className="mt-1"
                        />
                    )} */}

                    {platform.website !== null && (
                        <Anchor
                            href={addUtmTrackingToUrl(platform.website)}
                            openInNewTab
                            analyticsLabel={
                                PlatformUserEvents.ClickIndividualWebsite
                            }
                        >
                            <Badge
                                label={
                                    <>
                                        Website
                                        <FontAwesomeIcon
                                            icon={faExternalLink}
                                            className="h-3 ml-1.5"
                                        />
                                    </>
                                }
                                variant={BadgeVariants.blue}
                                hover
                                className="px-3 py-0.5"
                                size="sm"
                                rounded="md"
                            />
                        </Anchor>
                    )}
                </div>
            )}

            <DescriptionDisplay description={platform.description} />
        </>
    );
}
